import firebase from "firebase/compat/app";
import 'firebase/compat/firestore';
import 'firebase/compat/storage'
import 'firebase/compat/auth'
const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyDO6MLBMbh0lTdrxmKHBaXgimP-Y4_SMTY",
  authDomain: "pocdoc-148bb.firebaseapp.com",
  databaseURL: "",
  projectId: "pocdoc-148bb",
  storageBucket: "gs://pocdoc-148bb.appspot.com",
  messagingSenderId: "428431517667"
})
const db = firebaseApp.firestore()
export const storage = firebase.storage()
export const auth = firebase.auth()
export default db